import EventsCalendarPage from "@/pages/EventsCalendar";
export default function CalendarPage(props) {
	return <EventsCalendarPage {...props} mode="scouting" />;
}
